import { useState, useEffect } from 'react';
import isServiceAllowed from '../../../../../../../utils/steps/bookingform/getAllowedServices';

export const useServiceAllowed = serviceCode => {
  const [allowsService, setAllowsService] = useState(null);
  const [isChecking, setIsChecking] = useState(false);

  useEffect(() => {
    if (!serviceCode || serviceCode === 'INS') {
      setAllowsService(true);
      return;
    }
    if (serviceCode === 'ATP' || serviceCode === 'IPL' || serviceCode === 'IPR') {
      setAllowsService(false);
      return;
    }

    (async () => {
      setIsChecking(true);
      try {
        const result = await isServiceAllowed(serviceCode);
        setAllowsService(result.serviceAllowed);
      } catch (error) {
        console.error('Error fetching service allowance:', error);
        setAllowsService(false);
      }
      setIsChecking(false);
    })();
  }, [serviceCode]);

  return { allowsService, isChecking };
};
